<template>
  <v-container fluid>
    <v-row>
      <v-progress-circular
        v-show="approveloading || declineloading"
        color="secondary"
                class="accent--text logoutbtn"
        size="25"
        indeterminate
      ></v-progress-circular>
      <v-col cols="12" md="3" xs="6">
        <h2 class="white--text">Dispatch Files</h2>
      </v-col>
      <v-spacer></v-spacer>

      <!--      <v-spacer></v-spacer>-->

      <v-col
        cols="6"
        v-if="$can('CAN_UPLOAD_GRN')"
        class="d-flex justify-center"
      >
        <!-- <v-btn color="#7BC243" @click="uploadGrnFileDialog" class="white--text cataloguebtn">Upload Dispatch File </v-btn> -->
        <v-btn
          color="#7BC243"
          @click="termsDialog"
          class="white--text parchmentbtn"
          >Upload Dispatch File
        </v-btn>
      </v-col>
      <v-col
        cols="6"
        v-if="$can('CAN_UPLOAD_GRN')"
        class="d-flex justify-center"
      >
        <v-btn
          color="#3386FF"
          @click="downloadDispatchFile"
          class="white--text parchmentbtn"
          >Dispatch Template
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <v-layout>
      <v-flex xs12>
        <div
          :class="
            paginatedFiles.length === 7
              ? 'catalogue_box'
              : 'catalogue_box_empty'
          "
        >
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span
                  class="accent--text"
                  style="font-size: 14px; font-weight: 700"
                >
                  Uploaded Dispatch Files
                </span>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="search"></v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table
              v-model="selected"
              :headers="fileHeaders"
              :items="filteredList"
              item-key="id"
              class="elevation-1"
              :loading="loading"
              hide-default-footer
            >
              <template v-slot:item="props">
                <!--              <tr v-for="file in filteredList" v-bind:key="file.id">-->
                <tr :key="props.item.id">
                  <td>{{ props.item.fileName }}</td>
                  <!-- <td>{{ props.item.saleNumber }}</td> -->
                  <td>{{ props.item.numberOfLots }}</td>
                  <td>{{ props.item.totalBags }}</td>
                  <td>{{ props.item.totalWeight }}</td>
                  <td>{{ props.item.createdBy }}</td>
                  <!-- <td>{{ props.item.status.statusName }}</td> -->
                  <td
                    :class="{
                      'text-danger font-size-12 ':
                        `${props.item.status.statusName}` ===
                        'FAILED_VALIDATION',
                      'text-warning font-size-12 ':
                        `${props.item.status.statusName}` ===
                        'FAILED_VALIDATION',
                    }"
                  >
                    {{ props.item.status.statusName }}
                  </td>
                  <td>{{ props.item.dateCreated | formatDate }}</td>
                  <td class="actions">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          v-on="on"
                          text
                          icon
                          class="actions"
                        >
                          <v-icon class="secondary--text"> more_horiz</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-bind:to="'/grnfile/' + props.item.id + '/checkoffSettlementDetails'"
                        >
                          <v-list-item-title> View</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="props.item.status.id === 58"
                          v-bind:to="'/grnfile/' + props.item.id + '/deleted'"
                        >
                          <v-list-item-title> View Deleted</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="catalogFile(props.item)"
                          @click="getCatalogueFile(props.item)"
                        >
                          <v-list-item-title>
                            Catalogue File
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="canBeApproved(props.item)"
                          @click="confirmAction(props.item, 'approve')"
                        >
                          <v-list-item-title> Approve</v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item
                          v-if="canBeDeclined(props.item)"
                          @click="confirmAction(props.item, 'decline')"
                        >
                          <v-list-item-title> Decline</v-list-item-title>
                        </v-list-item> -->

                        <v-list-item
                          v-if="canBeDropped(props.item)"
                          @click="confirmAction(props.item, 'delete')"
                        >
                          <v-list-item-title>
                            Drop Dispatch File
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            props.item.status.id === 64 &&
                            $can('CAN_APPROVE_GRN')
                          "
                          @click="confirmAction(props.item, 'approve-deletion')"
                        >
                          <v-list-item-title>
                            Approve Deletion of File
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            props.item.status.id === 64 &&
                            $can('CAN_APPROVE_GRN')
                          "
                          @click="confirmAction(props.item, 'decline-deletion')"
                        >
                          <v-list-item-title>
                            Reject Deletion of File
                          </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="downloadGRNFile(props.item)">
                          <v-list-item-title> Download</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                          v-if="props.item.status.id === 88"
                          @click="downloadErrorFile(props.item)"
                        >
                          <v-list-item-title class="text-danger font-size-12"
                            >Download Error File</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <span class="paginationtext">
              Showing {{ page }} of {{ numberOfLinks }} pages
            </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              :total-visible="7"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>
        </div>
      </v-flex>
      <v-dialog v-model="confirmDialog" max-width="400">
        <v-card>
          <v-card-title
            class="body-2 primary--text font-weight-bold text-capitalize"
            >{{ this.action }} Dispatch File
          </v-card-title>
          <v-card-text class="primary--text">
            {{ confirmMessage }}
            <v-text-field
              name="comment"
              label="Comment"
              v-model="confirmFile.approverComment"
              :rules="commentRules"
              required
            >
            </v-text-field>

            <!-- Loader (spinner) -->
            <v-progress-circular
              v-if="sloading"
              indeterminate
              color="primary"
              size="40"
              class="d-block mx-auto mt-4"
            ></v-progress-circular>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="confirmDialog = false"
              class="font-weight-bold"
            >
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              class="accent--text logoutbtn"
              :disabled="sloading"
              @click="approveOrDecline(confirmFile)"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="overlayVisible" fullscreen hide-overlay>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-actions>
                  <v-progress-circular
                    v-show="approveloading || declineloading"
                    color="secondary"
                class="accent--text logoutbtn"
                    size="25"
                    indeterminate
                  ></v-progress-circular>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="white"
                    class="accentd--text"
                    style="font-weight: 700"
                    @click="overlayVisible = false"
                  >
                    Close
                  </v-btn>
                </v-card-actions>
                <v-card-title>
                  <v-row>
                    <v-col cols="4" md="4">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search By Outturn"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="8" class="text-right">
                      <h4>{{ confirmMessage }}</h4>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    v-model="selectedItems"
                    :headers="headers"
                    :items="grnRecords"
                    item-key="id"
                    show-select
                    class="elevation-1"
                    :search="search"
                    :single-select="false"
                  >
                    <template v-slot:top>
                      <v-btn
                        class="mr-4"
                        @click="approveOrDecline('approve')"
                        color="primary"
                        >Approve Selected/Reject Non Selected
                      </v-btn>

                      <v-btn
                        class="ml-4"
                        @click="approveOrDecline('decline')"
                        color="warning"
                        >Reject Selected/Approve Non Selected
                      </v-btn>
                    </template>
                    <template
                      v-slot:[`item.data-table-select`]="{ isSelected, select }"
                    >
                      <v-simple-checkbox
                        :ripple="false"
                        color="green"
                        :value="isSelected"
                        @input="select($event)"
                      ></v-simple-checkbox>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>

      <v-dialog v-model="confirmDeleteDialog" max-width="400">
        <v-card>
          <v-card-title
            class="body-2 primary--text font-weight-bold text-capitalize"
            >{{ this.action }} Dispatch File
          </v-card-title>
          <v-card-text class="primary--text">
            {{ confirmMessage }}
            <v-text-field
              name="comment"
              label="Comment"
              v-model="confirmFile.approverComment"
              :rules="commentRules"
              required
            >
            </v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="confirmDeleteDialog = false"
              class="font-weight-bold"
            >
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              class="accent--text logoutbtn"
              @click="allowDelete(confirmFile)"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="uploadFileDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline accent--text"
            >Upload Dispatch File
          </v-card-title>
          <!--          <v-card-subtitle
            v-if="isUploadDisabled"
            class="accent&#45;&#45;text"
            style="color: darkred !important"
          >Your timeline for file upload has elapsed
          </v-card-subtitle
          >-->

          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <!--              <v-col
                class="accent&#45;&#45;text"
                style="font-size: 14px; font-weight: 700"
              >
                <div>
                  {{ days }} Days {{ hours }} Hrs {{ minutes }} Mins
                  {{ seconds }} Seconds
                </div>
                Remaining for Sale No. {{ saleNo }} Sale Date
                {{ saleDate }}
              </v-col
              >-->
              <label
                >File
                <input
                  type="file"
                  id="file"
                  ref="file"
                  v-on:change="handleFileUpload()"
                  required
                />
              </label>
            </v-form>

            <!-- Show loader during upload -->
            <!--            <v-progress-circular-->
            <!--              v-if="fileloading"-->
            <!--              indeterminate-->
            <!--              color="primary"-->
            <!--              size="64"-->
            <!--              class="my-4"-->
            <!--            ></v-progress-circular>-->

            <!-- Show progress bar -->
            <!--            <v-progress-linear-->
            <!--              v-if="progress > 0 && !fileloading"-->
            <!--              :value="progress"-->
            <!--              height="20"-->
            <!--              color="blue"-->
            <!--              class="my-4"-->
            <!--            ></v-progress-linear>-->
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="white"
              class="accentd--text"
              style="font-weight: 700"
              @click="uploadFileDialog = false"
              >Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              :loading="fileloading"
              @click="uploadGRNFile"
              >Upload</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="downloadFileDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline accent--text"
            >Dispatch File</v-card-title
          >
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <div class="form-group">
                <label class="control-label" for="saleNo">Sale No.</label>
                <input
                  id="saleNo"
                  ref="saleNo"
                  class="form-control"
                  type="text"
                  placeholder="Sale No."
                  required
                />
              </div>

              <div class="form-group">
                <label class="control-label" for="season">Season</label>
                <input
                  id="season"
                  ref="season"
                  class="form-control"
                  type="text"
                  placeholder="Season"
                  required
                />
              </div>
              <div class="form-group">
                <label class="control-label" for="date">Date</label>
                <input
                  id="date"
                  ref="date"
                  class="form-control"
                  type="date"
                  placeholder="date"
                  required
                />
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="downloadFileDialog = false"
              >Cancel</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn color="secondary"
                class="accent--text logoutbtn" @click="downloadDispatchFile">Get File</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="termsAndConditionsDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline accent--text"
            >Terms and Conditions
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <label
                >I hereby confirm that the data provided is authentic and
                dependable, and can be utilized by DSS to process payments.
              </label>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="white"
              class="accentd--text"
              style="font-weight: 700"
              @click="termsAndConditionsDialog = false"
              >Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="uploadGrnFileDialog">Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import store from "../../../store";
import { mapState, mapActions } from "vuex";
import config from "@/config";
import axios from "axios";
import { Common } from "@/components/views/file/common";

export default {
  name: "catalogueupload",
  data: function () {
    return {
      overlayVisible: false,
      headers: [
        { text: "OutTurn", value: "outTurnNumber" },
        { text: "Grade", value: "grade" },
        { text: "Marks", value: "marks" },
        { text: "Bags", value: "bags" },
        { text: "Pockets", value: "pockets" },
        { text: "Season", value: "season" },
        // { text: "SaleNo", value: "saleNumber" },
        { text: "Miller", value: "millerCode" },
        { text: "Broker", value: "brokerCode" },
        { text: "GrossW", value: "grossWeight" },
        { text: "TareW", value: "tareWeight" },
        { text: "NetW", value: "netWeight" },
        // { text: 'Status', value: 'status.statusName' }
        // { text: 'Actions', value: 'actions' }
      ],
      fileHeaders: [
        { text: "FileName", value: "fileName" },
        // { text: "SaleNo.", value: "saleNumber" },
        { text: "Lots", value: "numberOfLots" },
        { text: "Bags", value: "totalBags" },
        { text: "Weight", value: "totalWeight" },
        { text: "UploadedBy", value: "createdBy" },
        { text: "Status", value: "status.statusName" },
        { text: "Date", value: "dateCreated" },

        { text: "Actions", value: "actions" },
      ],

      selected: [],
      selectedItems: [],
      grnRecords: [],
      fileId: "",
      singleSelect: false,
      valid: true,
      file: "",
      totalFiles: 0,
      pagination: { sortBy: "id", descending: true },
      search: "",
      permissions: [],
      approveloading: false,
      declineloading: false,
      paginatedFiles: [],
      numberOfLinks: 0,
      numberOfItemsPerPage: 10,
      // window.innerHeight <= 600
      // 	? 10
      // 	: window.innerHeight > 600 && window.innerHeight <= 1000
      // 		? 10
      // 		: 20,
      page: 1,
      timerContent: true,
      currentPage: 0,
      numberOfLinks1: 0,
      confirmDialog: false,
      confirmDeleteDialog: false,
      downloadFileDialog: false,
      confirmFile: {},
      confirmMessage: "",
      remainingTime: 0, // Total time in days
      interval: null,
      targetDate: "",
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      saleNo: "",
      saleDate: "",
      isUploadDisabled: false,
      action: "",
      uploadFileDialog: false,
      termsAndConditionsDialog: false,
      commentRules: [(v) => !!v || "Comment is required"],
      sloading: false,
      fileloading: false, // Indicates if the file is being uploaded
      progress: 0, // Tracks upload progress
    };
  },
  mounted() {
    this.permissions = store.state.user.roleId.permissions;
    this.startCountdown();
    this.getUpcomingDate();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  watch: {
    files() {
      this.paginatedFiles = this.files;
      // this.paginatedFiles = this.paginationMethod(this.files, 1, this.paginationInfo.size)
      this.numberOfLinks = this.paginationInfo.totalPages;
      this.numberOfItemsPerPage = this.paginationInfo.size;
      this.currentPage = this.paginationInfo.number;
    },
    page: function (val) {
      // this.paginatedFiles = this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
      this.$store.dispatch("grnfile/getFilesWithPagination", {
        size: this.numberOfItemsPerPage,
        page: val - 1,
      });
    },
  },
  computed: {
    ...mapState({
      files: (state) => state.grnfile.files,
      paginationInfo: (state) => state.grnfile.paginationInfo,
      loading: (state) => state.grnfile.loading,
    }),
    filteredList: function () {
      if (this.search === "") {
        return this.paginatedFiles;
      } else {
        return this.files.filter((file) => {
          const searchTerm = this.search.toLowerCase();
          var date = new Date(file.created);
          var year = date.getFullYear();
          var month = (1 + date.getMonth()).toString();
          month = month.length > 1 ? month : "0" + month;
          var day = date.getDate().toString();
          day = day.length > 1 ? day : "0" + day;
          var formatDate = day + "/" + month + "/" + year;
          return (
            file.fileName.toLowerCase().includes(searchTerm) ||
            file.totalBags.toString().includes(searchTerm) ||
            file.totalWeight.toString().includes(searchTerm) ||
            file.status.statusName.toLowerCase().includes(searchTerm) ||
            file.createdBy.toLowerCase().includes(searchTerm) ||
            formatDate.toString().toLowerCase().includes(searchTerm)
          );
        });
        // return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
      }
    },
  },
  methods: {
    ...mapActions({
      uploadFile: "grnfile/uploadFile",
      approveFile: "grnfile/approveFile",
      rejectFile: "grnfile/rejectFile",
      download: "grnfile/download",
      deleteFile: "grnfile/deleteFile",
    }),
    showOverlay() {
      this.overlayVisible = true;
    },

    downloadDispatchDialog() {
      this.downloadFileDialog = true;
    },
    getDispatchFileDetails(id) {
      const url = config.serverURI + "/grn_record/checkoffSettlementDetails?fileId=" + id;

      axios({ url: url, method: "GET" })
        .then((response) => {
          console.log(response.data);
          this.grnRecords = response.data;
        })
        .catch((error) => {
          // Request failed.
          console.log("error", error.response);
          this.grnRecords = [];
        });
    },
    downloadDispatchFile() {
      // const url = config.serverURI + '/files/downloads?filename=dispatch&season=' + this.$refs.season.value +
      //   '&saleNo=' + this.$refs.saleNo.value + '&date=' + this.$refs.date.value
      const url =
        config.serverURI +
        "/files/downloads?filename=dispatch&season=2023/2024&saleNo=33&date=12-04-2025";

      axios({ url: url, method: "GET", responseType: "blob" })
        .then((response) => {
          this.downloadFileDialog = false;

          // console.log(response)

          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/vnd.ms-excel" })
          );
          const link = document.createElement("a");
          link.href = url;
          //const itemFileName = 'dispatch_' + this.$refs.saleNo.value + '_' + this.$refs.season.value?.replace(/\//g, '_') + '.xlsx'
          const itemFileName = "dispatch_template.xlsx";
          link.setAttribute("download", itemFileName);
          document.body.appendChild(link);
          link.click();

          this.message = response.message;
          this.snackbar = true;
          this.snackbarColor = "primary";
        })
        .catch((error) => {
          console.log("error", error.response);
          // this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
          Common.blobToJson(error.response.data)
            .then((jsonData) => {
              this.message =
                typeof jsonData.message !== "undefined"
                  ? jsonData.message
                  : error.response.status + " Request failed";
            })
            .catch((error) => {
              console.error("Error:", error);
              this.message =
                typeof error.response.data.message !== "undefined"
                  ? error.response.data.message
                  : error.response.status + ": Error occurred";
            });
          this.snackbar = true;
          this.snackbarColor = "error";
          this.downloadFileDialog = false;
        });
      this.handleFileUpload();
    },
    startCountdown() {
      this.interval = setInterval(this.updateCountdown, 1000);
    },
    updateCountdown() {
      const now = new Date().getTime();
      const distance = this.targetDate - now;

      if (distance < 0) {
        clearInterval(this.interval);
        this.isUploadDisabled = true;
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
        return;
      }

      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
    },
    getUpcomingDate() {
      const fileType = "GRN";
      const token = localStorage.getItem("token");
      const tokenconfig = { headers: { Authorization: `Bearer ${token}` } };
      const upcomingDate =
        config.serverURI + "/timer/upcomingdatewh/" + fileType;
      const request = axios.get(upcomingDate, { tokenconfig });
      axios
        .all([request])
        .then(
          axios.spread((...responses) => {
            const response = responses[0];
            this.remainingTime = response.data.timeInMillis;
            this.saleNo = response.data.saleNo;
            this.saleDate = response.data.saleDate;
            // if (this.remainingTime === 0) {
            // 	this.targetDate = 'empty'
            // 	console.log('zero22')
            // 	// this.isUploadDisabled = false
            // 	clearInterval(this.interval)
            // 	this.isUploadDisabled = true
            // 	this.timerContent = true
            // 	$('#timer').css('display', 'none')
            // } else {
            // 	this.targetDate = this.remainingTime //new Date().getTime() + parseInt(this.remainingTime) * 60 * 1000
            // }
            this.targetDate = this.remainingTime;
            // this.targetDate = new Date().getTime() + parseInt(this.remainingTime) * 24 * 60 * 60 * 1000
            // this.targetDate = new Date().getTime() + parseInt(this.remainingTime) * 60 * 1000
          })
        )
        .catch((errors) => {
          console.log(errors);
        });
    },
    getCatalogueFile(file) {
      const url =
        config.serverURI + "/files/downloads?filename=catalogue&id=" + file.id;

      axios({ url: url, method: "GET", responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/vnd.ms-excel" })
          );
          const link = document.createElement("a");
          link.href = url;
          const lastUnderscoreIndex = file.fileName.lastIndexOf("_");
          const secondLastUnderscoreIndex = file.fileName.lastIndexOf(
            "_",
            lastUnderscoreIndex - 1
          );
          const thirdLastUnderscoreIndex = file.fileName.lastIndexOf(
            "_",
            secondLastUnderscoreIndex - 1
          );
          const extractedSuffix = file.fileName.slice(
            file.fileName.lastIndexOf("_", thirdLastUnderscoreIndex) + 1
          );
          const itemFileName = "catalogue_" + extractedSuffix;

          // const itemFileName = 'parchment_' + this.$refs.saleNo.value + '_' + this.$refs.season.value?.replace(/\//g, '_') + '.xlsx'
          link.setAttribute("download", itemFileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          // Request failed.
          console.log("error", error.response);
        });
      // return this.files
    },
    confirmAction2(item, action) {
      this.getDispatchFileDetails(item.id);
      this.overlayVisible = true;
      this.action = action;
      this.confirmMessage = item.fileName;
      this.fileId = item.id;
    },
    confirmAction(item, action) {
      this.confirmFile = item;
      this.confirmDeleteDialog = true;
      this.action = action;
      if (action === "delete") {
        this.confirmMessage =
          "Delete File " +
          item.fileName +
          " ?" +
          ".This action is irreversible";
      } else if (action === "approve-deletion") {
        this.confirmMessage =
          "Approve Deletion of File " + item.fileName + " ?";
      } else if (action === "decline-deletion") {
        this.confirmMessage = "Reject Deletion of File " + item.fileName + " ?";
      } else if (action === "approve") {
        this.confirmMessage = "Approve File " + item.fileName + " ?";
      } else if (action === "decline") {
        this.confirmMessage = "Reject File " + item.fileName + " ?";
      } else {
        console.error(action + "Action not supported");
      }
    },
    catalogFile(item) {
      return item.status.statusName === "APPROVED";
    },
    canBeApproved(item) {
      return item.status.id === 3 && this.hasPerm("CAN_APPROVE_GRN");
    },
    canBeDropped(item) {
      return item.status.id === 1 && this.hasPerm("CAN_UPLOAD_GRN");
    },
    canBeDeclined(item) {
      return item.status.id === 3 && this.hasPerm("CAN_APPROVE_GRN");
    },
    paginationMethod(items, pageNumber, limitPerPage) {
      console.log(limitPerPage);
      pageNumber = pageNumber - 1;
      const from = pageNumber * limitPerPage;
      let to = (pageNumber + 1) * limitPerPage;
      if (to >= items.length) {
        to = items.length;
      }
      return items.slice(from, to);
    },
    hasPerm(permission) {
      return this.permissions.includes(permission);
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    approveOrDecline(file) {
      if (this.action === "approve") {
        // if (operation === 'approve' || operation === 'decline') {
        // 	const data = this.selectedItems.map(item => {
        // 		return {
        // 			id: item.id,
        // 			outTurnNumber: item.outTurnNumber
        // 		}
        // 	})

        // this.approve({
        // 	id: this.fileId,
        // 	approverComment: operation + ' ' + this.selectedItems.length + ' out of ' + this.grnRecords.length,
        // 	action: operation,
        // 	data: data
        // })

        this.approveFile(file);
      } else if (this.action === "decline") {
        this.decline(file);
      } else {
        console.error("Function not supported");
      }
      // this.confirmApproveRejectDialog = false
      // this.confirmFile = {}
    },
    allowDelete(file) {
      if (this.action === "delete") {
        this.approvedelete(file);
      } else if (this.action === "approve") {
        this.approve(file);
      } else if (this.action === "approve-deletion") {
        this.approvedeletion(file);
      } else if (this.action === "decline-deletion") {
        this.rejectdeletion(file);
      } else if (this.action === "decline") {
        this.decline(file);
      } else {
        console.error("Function not supported");
      }
    },

    approvedelete(item) {
      this.approveloading = true;
      const url = config.serverURI + "/grn_record/delete-grnFile";
      axios
        .post(url, item)
        .then((response) => {
          if (response.data.error !== false) {
            this.message = response.data.message;
            this.snackbar = true;
            this.snackbarColor = "error";
          } else {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "primary",
              message: response.data.message,
            });
            this.message = response.data.message;
            this.snackbar = true;
            this.snackbarColor = "primary";
            this.confirmDeleteDialog = false;
          }
        })
        .catch((error) => {
          console.log("error..........", error.response);
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data.message,
          });
          // this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
          // this.snackbar = true
          // this.snackbarColor = 'error'
          this.confirmDeleteDialog = false;
        });
      this.confirmDeleteDialog = false;
      this.approveloading = false;
      this.getUploadedFiles(this.currentPage);
    },

    approvedeletion(item) {
      this.approveloading = true;
      const url = config.serverURI + "/grn_record/approve-delete-grnFile";
      axios
        .post(url, item)
        .then((response) => {
          if (response.data.error !== false) {
            this.message = response.data.message;
            this.snackbar = true;
            this.snackbarColor = "error";
          } else {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "primary",
              message: response.data.message,
            });
            this.message = response.data.message;
            this.snackbar = true;
            this.snackbarColor = "primary";
          }
        })
        .catch((error) => {
          console.log("error..........", error.response);
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data.message,
          });
          // this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
          // this.snackbar = true
          // this.snackbarColor = 'error'
          // this.confirmApproveRejectDialog = false
        });
      this.confirmDeleteDialog = false;
      this.approveloading = false;
      this.getUploadedFiles(this.currentPage);
    },

    rejectdeletion(item) {
      this.approveloading = true;
      const url = config.serverURI + "/grn_record/reject-delete-grnFile";
      axios
        .post(url, item)
        .then((response) => {
          // this.confirmApproveRejectDialog = false
          if (response.data.error !== false) {
            this.message = response.data.message;
            this.snackbar = true;
            this.snackbarColor = "error";
          } else {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "primary",
              message: response.data.message,
            });
            this.message = response.data.message;
            this.snackbar = true;
            this.snackbarColor = "primary";
          }
        })
        .catch((error) => {
          console.log("error..........", error.response);
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data.message,
          });
          // this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
          // this.snackbar = true
          // this.snackbarColor = 'error'
          // this.confirmApproveRejectDialog = false
        });
      this.confirmDeleteDialog = false;
      this.approveloading = false;
      this.getUploadedFiles(this.currentPage);
    },

    approve(file) {
      this.approveloading = true;
      this.approveFile(file)
        .then((response) => {
          if (response.data.error === false) {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: 'primary',
              message: response.data.message,
            });
          } else {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: response.data.message,
            });
          }
          this.confirmDialog = false;
          this.approveloading = false;
          this.overlayVisible = false;
          // this.$store.dispatch('grnfile/getFiles')
          this.$store.dispatch("grnfile/getFilesWithPagination", {
            size: this.numberOfItemsPerPage,
            page: this.currentPage,
          });
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
          this.confirmDialog = false;
          this.approveloading = false;
        });
    },
    decline(file) {
      // this.confirmApproveRejectDialog = false
      this.rejectFile(file)
        .then((response) => {
          if (response.data.error === false) {
            console.log("Response+++", response);
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: 'primary',
              message: response.data.message,
            });
          } else {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: response.data.message,
            });
          }

          this.confirmDialog = false;
          this.declineloading = false;
          // this.$store.dispatch('grnfile/getFiles')
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
          this.confirmDialog = false;
          this.declineloading = false;
          this.$store.dispatch("grnfile/getFilesWithPagination", {
            size: this.numberOfItemsPerPage,
            page: this.currentPage,
          });
        });
    },
    uploadGRNFile() {
      if (this.$refs.form.validate()) {
        if (!this.file) {
          this.snackbar = true;
          this.snackbarColor = "error";
          this.message = "Please select a file before uploading.";
          return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(this.file); // Convert file to Base64

        reader.onload = () => {
          const base64String = reader.result.split(",")[1]; // Extract the actual Base64 content

          const payload = {
            fileName: this.file.name,
            fileType: this.file.type,
            fileData: base64String,
          };

          const url = config.serverURI + "/grn_record";
          this.uploadLoading = true;
          this.fileloading = true;
          this.progress = 0;

          axios
            .post(url, payload)
            .then(() => {
              this.uploadLoading = false;
              this.fileloading = false;
              this.uploadFileDialog = false;

              this.$store.dispatch("grnfile/getFilesWithPagination", {
                size: this.numberOfItemsPerPage,
                page: 0,
              });

              this.$store.dispatch("alert/displayAlert", {
                snackbar: true,
                color: 'primary',
                message: "File uploaded successfully",
              });
            })
            .catch((error) => {
              this.uploadLoading = false;
              this.fileloading = false;
              this.uploadFileDialog = false;

              let errorMessage = "Network error or server unreachable";
              if (error.response) {
                Common.blobToJson(error.response.data)
                  .then((jsonData) => {
                    errorMessage =
                      jsonData.message ||
                      `${error.response.status} Request failed`;
                  })
                  .catch(() => {
                    errorMessage =
                      error.response.data?.message || "An error occurred";
                  })
                  .finally(() => {
                    this.$store.dispatch("alert/displayAlert", {
                      snackbar: true,
                      color: "error",
                      message: errorMessage,
                    });
                  });
              } else {
                this.$store.dispatch("alert/displayAlert", {
                  snackbar: true,
                  color: "error",
                  message: errorMessage,
                });
              }
            });
        };

        reader.onerror = () => {
          this.snackbar = true;
          this.snackbarColor = "error";
          this.message = "Error reading file. Please try again.";
        };
      }
    },

    termsDialog() {
      this.termsAndConditionsDialog = true;
    },
    uploadGrnFileDialog() {
      this.termsAndConditionsDialog = false;
      this.uploadFileDialog = true;
    },
    downloadGRNFile(item) {
      this.download(item.id)
        .then((response) => {
          const dataType = response.data.type;
          const objectCreationType =
            dataType === "application/xlsx" || dataType === "application/xls"
              ? "application/vnd.ms-excel"
              : "application/pdf";
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: objectCreationType })
          );
          const link = document.createElement("a");
          link.href = url;
          const ext = dataType.split("/");
          const itemFileName =
            item.fileName.split(".")[0] +
            "_" +
            item.created +
            "." +
            ext[ext.length - 1];

          link.setAttribute("download", itemFileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
        });
    },
    downloadErrorFile(item) {
      const url =
        config.serverURI + "/upload/parchment/download-error/" + item.id;
      axios({ url: url, method: "GET", responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          const itemFileName = "File_With_Errors_" + item.fileName;
          link.setAttribute("download", itemFileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          // Request failed.
          console.log("error", error.response);
          this.message = "Error occurred";
          this.snackbar = true;
          this.snackbarColor = "error";
        });
    },
  },
  created() {
    // this.$store.dispatch('grnfile/getFiles')
    this.$store.dispatch("grnfile/getFilesWithPagination", {
      size: this.numberOfItemsPerPage,
      page: 0,
    });
  },
};
</script>
<style>
.catalogue_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogue_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogue_box:after,
.catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513b !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733d29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733d29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #f2d0a7;
  color: #733d29;
}

.pagination > li.active > .page-link {
  background: #00513b;
  color: #fff;
}
</style>
